<template>
<div class="flex justify-center">
  <div class="shadow-lg my-4 p-6 rounded-lg w-auto md:w-2/3 md:mx-6">
    <div class="text-center text-xl font-medium border-b-2 rounded-sm
                 border-orange-academy-300 pb-1">
      {{ $t('student.progress') }}</div>
    <div class="mr-4 mt-5 text-left">
      {{$t('student.lessons')}} {{ lessonsCounter }}
    </div>
    <div class="mr-4 mt-5 text-left" v-if="user">
      <router-link :to="pathTeachers">
        {{$t('student.teachers')}} {{ teachersCounter }}
      </router-link>
    </div>
    <div class="mr-4 mt-5 text-left" v-else>
        {{$t('student.teachers')}} {{ teachersCounter }}
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    student: {},
  },

  data() {
    return {
      lessonsCounter: this.student.lessons_counter ? this.student.lessons_counter : 0,
      teachersCounter: this.student.teachers_counter ? this.student.teachers_counter : 0,
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),

    pathTeachers() {
      if (this.student.id === this.user.student.id) {
        return '/dashboard/teachers';
      }
      return `/student/${this.student.id}/teachers`;
    },
  },
};
</script>
